import React, { PureComponent, Fragment } from 'react';

import withSlide from '~/kits/general/scripts/components/withSlide';
import HalfDonut from '~/kits/general/scripts/components/HalfDonut';
import dataCsv from '~/assets/data/yearly_eu.csv';

import { numberFormat } from '~/core/scripts/utils';
import Icon from '~/core/scripts/components/Icon';

import './Intro.styl';

const data = dataCsv.map(d => [
  { seats: 100 - +d.rights, color: '#ddd', name: 'others', year: d.year },
  { seats: +d.rights, color: '#222', name: 'rights', year: d.year }
]);

class Intro extends PureComponent {
  state = {
    dataIndex: 0,
    isPlaying: false
  }

  timeout = null

  componentDidMount() {
    if (this.props.isActive) {
      this.animate();
    }
  }

  componentDidUpdate(lastProps) {
    if (this.props.isActive && !lastProps.isActive) {
      this.animate();
    } else if (!this.props.isActive) {
      this.stop();
    }
  }

  replay() {
    this.setState({ dataIndex: 0 }, () => this.animate());
  }

  stop() {
    window.clearTimeout(this.timeout);
    this.setState({ isPlaying: false });
  }

  animate() {
    this.setState({ isPlaying: true });

    this.timeout = window.setTimeout(() => {

      const nextIndex = this.state.dataIndex + 1;

      if (nextIndex === data.length) {
        return this.stop();
      }

      this.setState({ dataIndex: nextIndex });
      this.animate();
    }, 1000);
  }

  render() {
    const { title, text } = this.props;
    const { dataIndex } = this.state;

    return (
      <Fragment>

        <div className="headline">
          <div className="topline">
            {/* <time className="date">01.01.2016</time> */}
            <span className="kicker">Kurzanalyse der Europawahl 2019</span>
          </div>
          <h1 className="title">{title}</h1>
          <h3 className="introtext">{text}</h3>
        </div>

        <div className="donut-container">
          <div className="donut-viz">
            <HalfDonut data={data[dataIndex]} />
          </div>
          <div className="slide-share donut-share">Jahr {data[dataIndex][1].year}: <strong>{numberFormat(data[dataIndex][1].seats, 2)} %</strong></div>
          {/* <button onClick={() => this.replay()} className="btn btn-replay ghost light"><Icon type="play-circle"/> Replay</button> */}
          {(dataIndex === data.length - 1) && (<button onClick={() => this.replay()} className="btn btn-replay ghost light"><Icon type="play-circle"/> Replay</button>)}
        </div>
        
          <div className="intro__cta">
            <Icon type="slide"/>
            <div className="intro__cta-text">Swipen um weiterzublättern</div>
          </div>
      </Fragment>
    );
  }
}

export default withSlide(Intro);
